import React from "react";
import { X } from "lucide-react";

interface ErrorAlertProps {
  message: string;
  onClose: () => void;
  className?: string;
  autoDismiss?: boolean;
  dismissTime?: number;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  message,
  onClose,
  className = "",
  autoDismiss = true,
  dismissTime = 5000
}) => {
  React.useEffect(() => {
    if (autoDismiss) {
      const timer = setTimeout(() => {
        onClose();
      }, dismissTime);
      
      return () => clearTimeout(timer);
    }
  }, [autoDismiss, dismissTime, onClose]);

  return (
    <div 
      className={`relative rounded border border-red-400 bg-red-50 px-4 py-3 text-red-700 ${className}`}
      role="alert"
    >
      <strong className="font-medium block mb-1">Error!</strong>
      <span className="block sm:inline">{message}</span>
      <button
        type="button"
        className="absolute top-3 right-3 text-red-500 hover:text-red-700"
        onClick={onClose}
        aria-label="Close"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default ErrorAlert;